import styled from 'styled-components';

type PanelFooterProps = {
  // The container's side padding, so the divider reaches its edges.
  // Layout.Panel uses 30px.
  readonly $bleed?: number;
  readonly $direction?: 'row' | 'column';
};

// Bottom section of a panel or dialog: a full-width divider with the
// panel's buttons below it, evenly spaced. It sits in the page flow, so
// it needs no offsets when the content above or the buttons change size.
export const PanelFooter = styled('div')<PanelFooterProps>`
  display: flex;
  flex-direction: ${({ $direction }) => $direction ?? 'column'};
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 32px ${({ $bleed = 30 }) => -$bleed}px 0;
  padding: 32px ${({ $bleed = 30 }) => $bleed}px 0;
  border-top: 1px solid var(--border);
`;
